import { Component, Inject, Input, OnInit, effect} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService, IdentifierService } from 'merlin-core';
import { UserProfileObject, UserService } from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { PatientProfilePrintDialogService } from '../services/patient-profile-print-dialog.service';
import { FRANCE_COUNTRY_CODE } from '../../constants/france.constants';
import { BaselineClinicalData, DropDownsModel } from '../services/baseline-clinicaldata.model';
import { BaselineClinicalDataService } from '../services/baseline-clinicaldata.service';

@Component({
    selector: 'app-patient-profile-print-dialog',
    templateUrl: './patient-profile-print-dialog.component.html',
    styleUrls: ['./patient-profile-print-dialog.component.scss'],
    standalone: false
})
export class PatientProfilePrintDialogComponent implements OnInit {

    @Input() patRes: any;
    patientProfileData: any;
    userName: any;
    isICM: boolean = false;
    isLP: boolean = false;
    implantDate: string;
    patientData;
    medTeam;
    implantselectedItem;
    clinicLocation;
    gender;
    language;
    leadsData: any;
    isCountryFrance: boolean;
    isJapanseLocale: boolean = false;
    localizationService: any;
    istrueAaiDevice: any;
    pmDependent: any;


    public stringLabels = [
        "label.gb.merlin_net_patient_profile",
        "label.rpt.clinic_name",
        "label.gb.address",
        "label.gb.home_phone",
        "label.filter.patient_name",
        "label.gb.pat_record_no",
        "label.rpt.medical_team",
        "label.gb.patientdetailsbr",
        "label.filter.patient_name",
        "label.gb.cliniclocation",
        "label.gb.birth_date",
        "label.gb.gender",
        "label.gb.merlin_net_number",
        "label.gb.patient_speaks",
        "label.gb.INSnumber_long",
        "label.gb.firstname_long",
        "label.gb.givennames_long",
        "label.gb.firstname_used_long",
        "label.gb.lastname_long",
        "label.gb.lastname_used_long",
        "label.gb.OID",
        "label.gb.date_of_birth_long",
        "label.gb.Merlin.net_number",
        "label.gb.clinic_loc",
        "label.gb.merlin_net_enrollment",
        "label.gb.gender_long",
        "label.gb.birth_code_long",
        "label.gb.pat_prefers",
        "label.gb.SSN",
        "label.gb.patient_address_contact",
        "label.gb.address1",
        "label.gb.city",
        "label.gb.address2",
        "label.gb.state_province",
        "label.gb.address3",
        "label.gb.zip_post_code",
        "label.gb.phone",
        "label.gb.country",
        "label.gb.other_phone",
        "label.gb.email_addr",
        "label.gb.patient_device_information",
        "label.gb.dev_name",
        "label.gb.serial_no",
        "label.gb.implant_date",
        "label.gb.doc_perform_implant",
        "label.gb.dev_name",
        "label.gb.serial_no",
        "label.gb.implant_date",
        "label.gb.doc_perform_implant",
        "label.gb.lead_chamber",
        "label.gb.lead_model",
        "label.gb.lead_manufacturer",
        "label.gb.patient_clinical_status",
        "label.gb.pacemaker_dependent",
        "msg.pa059.text",
        "label.gb.close",
        "label.gb.print"
    ]

    public labels: Record<string, string>;

    constructor(
        private dataService: PatientProfilePrintDialogService,
        public identifierService: IdentifierService,
        private userService: UserService,
        private helperService: HelperService,
        private localization: LocalizationService,
        private baselineService : BaselineClinicalDataService,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        effect(() => {
            const lang = this.localization.currentLang();
            if (!lang) return;
            this.labels = this.localization.reparseLocalizedStrings(this.labels);
        });
        
        this.isICM = data.patRes?.patientDevices?.[0]?.isICMDevice || false;
        this.isLP = data.patRes?.patientDevices?.[0]?.isAveirDevice || false;
        this.implantDate = data.patRes?.patientDevices?.[0]?.implantDate;
        this.patientData = data.patRes;
        this.leadsData = data.patRes.leads;
        this.patientData?.medTeam?.assigned?.sort((a, b) => a?.id - b?.id);
        
        if (data?.patRes)
            this.patRes = data?.patRes
        }
    pacemakerDependentData() {
        this.baselineService.getData(this.data?.patientid).subscribe(
            (res: BaselineClinicalData) => {
                if (res) {
                    let pdCd = res?.pacemakerDependentCd;
                    let codeId = res?.pacemakerDependentList.filter((list: DropDownsModel) => list?.codeId == pdCd);
                    this.pmDependent = codeId?.length ? this.translate('data.Code.Pacemaker_Dependent_Cd.Code_Desc.'+codeId[0]?.code) : '';
                }
            })
    }
        
        ngOnInit(): void {
            this.translateStrings();
            this.getPrintData();
            this.pacemakerDependentData();
        this.userService
            .getUserProfile(false)
            .subscribe((userData: UserProfileObject) => {
                this.userName = userData.logonUserName;
                this.isCountryFrance =
                    userData.clinicCountryCd === FRANCE_COUNTRY_CODE;
            });
        this.medTeam = this.data.patRes?.medTeam;
        if (this.medTeam?.implantPhyId != null) {
            this.implantselectedItem = this.medTeam.implantPhyId;
        } else {
            this.implantselectedItem = 999999;
        }
        this.getLocation();
        this.getGender();
        this.getLanguage();
    }

    translateStrings(){
        this.labels = this.localization.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    getPrintData() {
        this.dataService
            .getData(this.data.patientid)
            .subscribe((data) => {
                this.patientProfileData = data;
                this.istrueAaiDevice = this.patientProfileData.deviceProduct.trueAaiCapableFlg;
            });
    }
    // patientCountry() {
    //     return this.patientProfileData?.patientDTO.address.countryCd?.toLowerCase();
    // }
    // clinicCountry() {
    //     return this.patientProfileData?.customerSummaryDTO?.addressDTO?.countryCd.toLowerCase();

    // }
    getCountry(countryCode) {
        if (countryCode) {
            const qualifier = this.patientProfileData.countryCodes?.find(a => a.codeId === countryCode);
            return this.localization.generateLocalizedStr(
                'data.Code.' + qualifier?.qualifier + '.Code_Desc.' + qualifier?.code
            );
        }
    }

    getPatientName(): string {
        return [this.patientProfileData?.patientDTO?.lastName, this.patientProfileData?.patientDTO?.firstName ].filter((item) => ![null, '' ].includes(item)).join ( ' , ' )
    }

    getTranslateTitle(): any {
        return (
            '<h3 style="font-size: 20px;color: black;">' +
            this.localization.generateLocalizedStr('label.gb.merlin_net') +
            '</h3>'
        );
    }

    getPhoneInfo(value) {
        if (value) {
            return value.toString().length > 3 ?
                value.toString().substring(0, 3) + ' ' + value.toString().slice(3).match(/\d{1,4}/g).join(' ') : value;
        }
        return value;
    }

    printPage() {
        // window.print();
        var printElement = document.getElementById('print-section');
        // document.body.classList.add("non-print");
        var printContents = document.getElementById('print-section').innerHTML;
        const template = document.createElement('div');
        template.innerHTML = printContents;
        template.setAttribute('id', 'printableDiv');
        template.classList.add('printableDiv');
        document.body.appendChild(template);
        this.setPageSize('8.3in 11.7in');
        setTimeout(() => {
            window.print();
            document.body.classList.remove('non-print');
            let mydiv = document.getElementById('printableDiv');
            mydiv.remove();
        }, 500);
    }
    setPageSize(size) {
        let style = document.createElement('style');
        style.innerHTML = `@media print {@page {size:${size};}}`;
        document.body.appendChild(style);
    }
    isViewImplanting(id: any) {
        return id == this.implantselectedItem;
    }
    getPhys(phys) {
        //return 'abc';
        let patPhys = this.data.patRes?.dropdowns?.clinicians.filter((dev) => {
            return dev.acctId != -1 && dev.acctId == phys;
        });
        if (patPhys?.length == 0) {
            return '';
        }
        return `${!patPhys[0].lastName 
             ? ''
            : this.translate(patPhys[0].lastName) + ','
           
            }
  ${!patPhys[0].firstName 
                 ? ''
                : ' ' + this.translate(patPhys[0].firstName)
               
            }
  ${!patPhys[0].middleName 
                 ? ''
                : ' ' + this.translate(patPhys[0].middleName)
               
            }
  ${!patPhys[0].credentialsCd 
                ? ''
                : ' ' + this.translate(patPhys[0].credentialsCd)
               
            }`;
    }

    translate(key: string) {
        if (key) return this.localization.generateLocalizedStr(key);
    }
    getLocation() {
        this.data?.patRes?.dropdowns?.locations.filter((data) => {
            if (data.value == this.patientData?.patient?.locationId) {
                this.clinicLocation = data?.label;
            }
        });
    }

    getGender() {
        this.data?.patRes?.dropdowns?.genderCodes.filter((data) => {
            if (data.codeId == this.data?.patRes?.patient?.genderCd) {
                this.gender = this.translate(`data.Code.Gender_Cd.Code_Desc.${data?.code}`);
            }
        });

        let patChamb = this.patRes.dropdowns?.genderCodes
        .filter((code) => {
            return code.codeId == this.patRes.patient?.genderCd;
        });
        if (!patChamb) {
            this.gender = '';
        } else {
            const genderText = this.formatDDString(patChamb[0]);
            this.gender = this.translate(genderText);
        }
    }

    getLanguage() {
        this.language ='';
        let patChamb = this.patRes.dropdowns?.langCodes.filter((code) => {
            return code.codeId == this.patRes.patient.languageCd;
        });
        if (!patChamb) {
            return '';
        } else {
            const langText = this.formatDDString(patChamb[0]);
            this.language =this.translate(langText);
        }
    }

    formatDDString(ddObj: any) {
        if (ddObj) {
            return this.localization.generateLocalizedStr(
                'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
            );
        } else {
            return '';
        }
    }
    getRace() {
        let patRace = this.patRes?.dropdowns?.raceCodes.filter((code) => {
            return code.codeId == this.patRes.patient?.raceCd;
        });
        if (!patRace) {
            return '';
        } else {
            const raceText = this.formatDDString(patRace[0]);
            return this.translate(raceText);
        }
    }
    ngOnDestroy() { this.setPageSize('landscape'); }
}
